import { useCallback } from 'react';
import { useDispatch } from 'react-redux';

import { closePopupAction } from '../store/actions';
import { useCombinedHandler } from 'js/hooks/useCombinedHandler';

/**
 * Default onClose handler. Closes current active popup unless specific popup id was specified.
 * @return {function(): *}
 */
export const useOnClose = (id) => {
    const dispatch = useDispatch();

    return useCallback(() => dispatch(closePopupAction(id)), [id, dispatch]);
};

export const useCombinedOnClose = (beforeCloseHandler, id) => {
    const closeManagedPopup = useOnClose(id);

    return useCombinedHandler([beforeCloseHandler, closeManagedPopup].filter(Boolean));
};

export const useFullyCombinedOnClose = (beforeCloseHandler, afterCloseHandler, id) => {
    const closeManagedPopup = useOnClose(id);

    return useCombinedHandler([beforeCloseHandler, closeManagedPopup, afterCloseHandler].filter(Boolean));
};
